import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { GroupActionService } from "../../shared/group-action.service";
import { GroupActionReminderUpdateRequest } from "../../shared/group-action-reminder-update-request";
import * as moment from "moment";

@Component({
	selector: "app-sgedit-reminder",
	templateUrl: "./sgedit-reminder.component.html",
	styleUrls: ["./sgedit-reminder.component.css"],
})
export class SGEditReminderComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: GroupActionService
	) {}

	ngOnInit(): void {
		this.GroupActionID = this.dialogConfig.data.GroupActionID;
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;
		this.GroupName = this.SelectedGroup.GroupName;

		this.loadGroupAction();
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	GroupActionID: number = -1;
	user: any;
	SchoolID: number = -1;
	SelectedGroup: any;

	GroupName: string = "";
	OriginalMessage: string = "";
	OriginalMessageFontColor: string = "#000000";
	AddAutomatically: boolean = false;

	//
	// Reminder Info
	//
	Message: string = "";
	MessageFontColor: string = "#000000";
	SelectedSound: any;
	lstSoundItems: any = [];
	SelectedAlertTypeID: number = 1;
	lstAlertType: any = [
		{
			ID: 1,
			Desc: "Play Once",
		},
		{
			ID: 2,
			Desc: "Play Until Removed",
		},
		{
			ID: 3,
			Desc: "Play in Date Range",
		},
	];
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	Priority: number = 2;
	lstPriority: any = [
		{
			ID: 1,
			Desc: "High",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 3,
			Desc: "Low",
		},
	];
	EntryMode: boolean = true;
	ExitMode: boolean = true;
	MealMode: boolean = true;
	AccessMode: boolean = true;
	TimeStampMode: boolean = true;
	EventEntryMode: boolean = true;
	EventExitMode: boolean = true;
	ParentPortalSendNotification: boolean = false;
	StudentPortalSendNotification: boolean = false;
	StaffPortalSendNotification: boolean = false;

	audio: any = new Audio();

	GroupActionLoading: boolean = true;
	SoundLoading: boolean = true;
	Processing: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////

	loadGroupAction() {
		this.GroupActionLoading = true;

		var result = this.dataService.GroupActionReminderSelect(this.GroupActionID);
		result.subscribe(
			(response: any) => {
				this.Message = String(response.Message);
				this.OriginalMessage = String(response.Message);
				this.MessageFontColor = String(response.MessageFontColor);
				this.OriginalMessageFontColor = String(response.MessageFontColor);
				this.SelectedAlertTypeID = response.AlertType;

				if (this.SelectedAlertTypeID == 3) {
					this.StartDate = new Date(response.StartDate);
					this.EndDate = new Date(response.EndDate);
				}

				this.Priority = response.Priority;
				this.EntryMode = response.EntryMode;
				this.ExitMode = response.ExitMode;
				this.MealMode = response.MealMode;
				this.AccessMode = response.AccessMode;
				this.TimeStampMode = response.TimeStampMode;
				this.EventEntryMode = response.EventEntryMode;
				this.EventExitMode = response.EventExitMode;
				this.ParentPortalSendNotification = response.ParentPortalSendNotification;
				this.StudentPortalSendNotification = response.StudentPortalSendNotification;
				this.StaffPortalSendNotification = response.StaffPortalSendNotification;
				this.AddAutomatically = response.AddStudentPrompt == true ? false : true;

				this.GroupActionLoading = false;

				this.loadSound(response.SoundLibraryID);
			},
			(error) => {
				this.GroupActionLoading = false;
			}
		);
	}

	loadSound(SoundLibraryID: number) {
		this.SoundLoading = true;

		//
		// Load school sounds or district-only sounds?
		// School-Only sounds might break for district-level alert
		//
		var result = this.dataService.LoadSoundPopupList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstSoundItems = response;

				this.lstSoundItems.unshift({
					SoundLibraryID: -1,
					SoundFile: "None",
					SoundData: null,
				});

				this.SelectedSound = this.lstSoundItems[0];

				if (SoundLibraryID > 0) {
					for (var z = 0; z < this.lstSoundItems.length; z++) {
						var next = this.lstSoundItems[z];

						if (next.SoundLibraryID == SoundLibraryID) {
							this.SelectedSound = next;
							break;
						}
					}
				}

				this.SoundLoading = false;
			},
			(error) => {
				this.SoundLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		if (String(this.Message).trim() == "") {
			this.errorMessage = "Enter new reminder message";
			return;
		}

		var fsDate: string = "";
		var feDate: string = "";

		if (this.SelectedAlertTypeID == 3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");

			if (String(fsDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid Start Date";
				return;
			}
			if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
				this.errorMessage = "Invalid End Date";
				return;
			}
		}

		this.confirmationService.confirm({
			key: "confirmeditreminder",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to reset which students already received the reminder?",
			header: "Reset Already Played",
			icon: "fa",
			accept: () => {
				this.onFinishUpdate(fsDate, feDate, 1);
			},
			reject: () => {
				this.onFinishUpdate(fsDate, feDate, 0);
			},
		});
	}

	onFinishUpdate(fsDate: string, feDate: string, ResetAlreadyPlayed: number) {
		this.Processing = true;

		var parms: GroupActionReminderUpdateRequest = {
			GroupActionID: this.GroupActionID,
			AddStudentPrompt: this.AddAutomatically == true ? 0 : 1,
			Message: this.Message,
			AlertType: this.SelectedAlertTypeID,
			MessageFontColor: this.MessageFontColor,
			SoundLibraryID: this.SelectedSound.SoundLibraryID,
			StartDate: fsDate,
			EndDate: feDate,
			Priority: this.Priority,
			EntryMode: this.EntryMode == true ? 1 : 0,
			ExitMode: this.ExitMode == true ? 1 : 0,
			MealMode: this.MealMode == true ? 1 : 0,
			AccessMode: this.AccessMode == true ? 1 : 0,
			TimeStampMode: this.TimeStampMode == true ? 1 : 0,
			EventEntryMode: this.EventEntryMode == true ? 1 : 0,
			EventExitMode: this.EventExitMode == true ? 1 : 0,
			ParentPortalSendNotification: this.ParentPortalSendNotification == true ? 1 : 0,
			StudentPortalSendNotification: this.StudentPortalSendNotification == true ? 1 : 0,
			StaffPortalSendNotification: this.StaffPortalSendNotification == true ? 1 : 0,
			ResetAlreadyPlayed: ResetAlreadyPlayed,
		};

		var result = this.dataService.GroupActionReminderUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.ref.close(1);
				} else {
					this.errorMessage = response.ErrorMessage;
				}

				this.Processing = false;
			},
			(error) => {}
		);
	}

	onClose() {
		this.onStop();
		this.ref.close(0);
	}

	onPlay() {
		this.errorMessage = "";

		if (this.SelectedSound == null || this.SelectedSound.SoundData == null) {
			this.errorMessage = "Select a sound to play";
			return;
		}

		this.audio.src = this.SelectedSound.SoundData;
		this.audio.load();
		this.audio.play();
	}

	onStop() {
		this.errorMessage = "";

		if (this.audio.src != null && this.audio.currentTime > 0) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////

	onSoundChange(val) {
		this.SelectedSound = val;

		this.onStop();
	}
	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////

	IsLoading() {
		return this.GroupActionLoading == true || this.SoundLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////
}
